import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import http from "../../Services/httpService";
import config from "../../config.json";
import { getConfirmAlert } from "../../Services/appAlerts";
class AddEditPermission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permissionData: [],
            mainMenu: [],
            systemAdminstration: [
            ],
            menuObjects: [
                {
                    id: 1,
                    name: "ADMINISTRATION",
                    menus: [
                        {
                            id: 1,
                            name: "Manage Users",
                            isChecked: false
                        }
                    ],
                    isChecked: false,
                },
                {
                    id: 1,
                    name: "CONTRACT MANAGEMENT",
                    menus: [
                        {
                            id: 2,
                            name: "Onboarding",
                            menus: [
                                {
                                    id: 1,
                                    name: "Contract Management",
                                    menus: [
                                        {
                                            id: 1,
                                            name: "ACH Information",
                                            isChecked: false
                                        },
                                        {
                                            id: 2,
                                            name: "Insurance Information",
                                            isChecked: false
                                        },
                                    ],
                                    isChecked: false
                                },
                                {
                                    id: 2,
                                    name: "Onboarding/Enrollment Status",
                                    isChecked: false
                                },
                            ],
                            isChecked: false,
                        },
                        {
                            id: 2,
                            name: "Time Log",
                            menus: [
                                { id: 1, name: "List of Candidates", isChecked: false },
                            ],
                            isChecked: false,
                        },
                        {
                            id: 3,
                            name: "Invoice",
                            menus: [
                                { id: 1, name: "Invoices and Payments", isChecked: false },
                            ],
                            isChecked: false,
                        },
                    ],
                    isChecked: false,
                },
            ],
            refMenuObjects: [
                {
                    id: 1,
                    name: "ADMINISTRATION",
                    menus: [
                        {
                            id: 1,
                            name: "Manage Users",
                            isChecked: false
                        }
                    ],
                    isChecked: false,
                },
                {
                    id: 2,
                    name: "CONTRACT MANAGEMENT",
                    menus: [
                        {
                            id: 1,
                            name: "Onboarding",
                            menus: [
                                {
                                    id: 1,
                                    name: "Contract Management",
                                    menus: [
                                        {
                                            id: 1,
                                            name: "ACH Information",
                                            isChecked: false
                                        },
                                        {
                                            id: 2,
                                            name: "Insurance Information",
                                            isChecked: false
                                        },
                                    ],
                                    isChecked: false
                                },
                                {
                                    id: 2,
                                    name: "Onboarding/Enrollment Status",
                                    isChecked: false
                                },
                            ],
                            isChecked: false,
                        },
                        {
                            id: 2,
                            name: "Time Log",
                            menus: [
                                { id: 1, name: "List of Candidates", isChecked: false },
                            ],
                            isChecked: false,
                        },
                        {
                            id: 3,
                            name: "Invoice",
                            menus: [
                                { id: 1, name: "Invoices and Payments", isChecked: false },
                            ],
                            isChecked: false,
                        },
                    ],
                    isChecked: false,
                },
            ],
        };
    }

    renderCheckBox = (label, name, handleOnChange, isChecked) => {
        return (
            <div className="">
                <div className="custom-control custom-checkbox">
                    <input
                        className="custom-control-input"
                        id={name}
                        type="checkbox"
                        name={name}
                        value="Yes"
                        onChange={handleOnChange}
                        checked={isChecked}
                    />

                    <label
                        className="custom-control-label form-control-label"
                        htmlFor={name}
                    >
                        {label}
                    </label>
                </div>
            </div>
        );
    };

    handleSystemAdminChange = ({ currentTarget }) => {
        const { menuObjects } = this.state;
        const mid = currentTarget.id.split("_");
        if (mid[0] === "m") {
            menuObjects
                .filter((x) => x.id === parseInt(mid[1]))
                .map((menu) => {
                    menu.isChecked = currentTarget.checked;
                    menu.menus.map((smenu) => {
                        smenu.isChecked = currentTarget.checked;
                        if (smenu.menus) {
                            smenu.menus.map((ssmenu) => {
                                ssmenu.isChecked = currentTarget.checked;
                                if (ssmenu.menus) {
                                    ssmenu.menus.map((sssmenu) => {
                                        sssmenu.isChecked = currentTarget.checked;
                                        return sssmenu;
                                    });
                                }
                                return ssmenu;
                            });
                        }
                        return smenu;
                    });
                    return menu;
                });
            this.setState({ menuObjects });
        }
        if (mid[0] === "sm") {
            menuObjects
                .filter((x) => x.id === parseInt(mid[2]))
                .map((menu) => {
                    menu.menus
                        .filter((x) => x.id === parseInt(mid[1]))
                        .map((smenu) => {
                            smenu.isChecked = currentTarget.checked;
                            if (smenu.menus) {
                                smenu.menus.map((ssmenu) => {
                                    ssmenu.isChecked = currentTarget.checked;
                                    if (ssmenu.menus) {
                                        ssmenu.menus.map((sssmenu) => {
                                            sssmenu.isChecked = currentTarget.checked;
                                            return sssmenu;
                                        });
                                    }
                                    return ssmenu;
                                });
                            }
                            return smenu;
                        });
                });
            this.setState({ menuObjects });
        }
        if (mid[0] === "ssm") {
            menuObjects
                .filter((x) => x.id === parseInt(mid[3]))
                .map((menu) => {
                    menu.menus
                        .filter((x) => x.id === parseInt(mid[2]))
                        .map((smenu) => {
                            smenu.menus
                                .filter((x) => x.id === parseInt(mid[1]))
                                .map((ssmenu) => {
                                    ssmenu.isChecked = currentTarget.checked;
                                    if (ssmenu.menus) {
                                        ssmenu.menus.map((sssmenu) => {
                                            sssmenu.isChecked = currentTarget.checked;
                                            return sssmenu;
                                        });
                                    }
                                    return ssmenu;
                                });
                            return smenu;
                        });
                    return menu;
                });
            this.setState({ menuObjects });
        }
        if (mid[0] === "sssm") {
            menuObjects
                .filter((x) => x.id === parseInt(mid[4]))
                .map((menu) => {
                    menu.menus
                        .filter((x) => x.id === parseInt(mid[3]))
                        .map((smenu) => {
                            smenu.menus
                                .filter((x) => x.id === parseInt(mid[2]))
                                .map((ssmenu) => {
                                    ssmenu.menus
                                        .filter((x) => x.id === parseInt(mid[1]))
                                        .map((sssmenu) => {
                                            sssmenu.isChecked = currentTarget.checked;
                                            return sssmenu;
                                        })
                                    return ssmenu;
                                });
                            return smenu;
                        });
                    return menu;
                });
            this.setState({ menuObjects });
        }
    };

    handleSubmit = async () => {
        const { menuObjects } = this.state;
        const { roleid, roleSource } = this.props;
        const permissionObj = {
            roleId: roleid,
            roleSource: roleSource,
            permissionRights: JSON.stringify(menuObjects),
        };
        const result = await getConfirmAlert("Are you sure?", `You want to Change Permissions to this User?`, "warning");
        if (result.isConfirmed) {
            const { data } = await http.post(
                config.AddEditRolePermission,
                permissionObj
            );
        }
        this.props.handlePermissionShowHide();
    };

    componentDidMount = async () => {
        const { roleid } = this.props;
        const { refMenuObjects } = this.state;
        if (roleid > 0) {
            const { data } = await http.get(
                config.GetRolePermission + roleid
            );
            if (data !== "") {
                this.setState({ menuObjects: data });
            } else {
                this.setState({ menuObjects: refMenuObjects });
            }
        } else {
            this.setState({ menuObjects: refMenuObjects });
        }
    }

    componentWillReceiveProps = async (nextProps) => {

    };

    render() {
        const { menuObjects } = this.state;
        return (
            <Modal show={this.props.showHide} size="xl">
                <Modal.Header closeButton onHide={this.props.handleModalShowHide}>
                    <Modal.Title>Add/Edit Key Contacts/Users</Modal.Title>
                </Modal.Header>
                <Modal.Body className="border">
                    <div className="card-columns">
                        {menuObjects.map((menu) => (
                            <div className="card shadow-none border">
                                <div className="card-header p-2 bg-secondary">
                                    <h3 className="mb-0">
                                        {this.renderCheckBox(
                                            menu.name,
                                            `m_${menu.id}`,
                                            this.handleSystemAdminChange,
                                            menu.isChecked
                                        )}
                                    </h3>
                                </div>
                                <div className="card-body p-3">
                                    {menu.menus?.map((smenu) => (
                                        <>
                                            <h4>
                                                {this.renderCheckBox(
                                                    smenu.name,
                                                    `sm_${smenu.id}_${menu.id}`,
                                                    this.handleSystemAdminChange,
                                                    smenu.isChecked
                                                )}
                                            </h4>
                                            {smenu.menus?.map((ssmenu) => (
                                                <ul className="list-group">
                                                    <li className="list-group-item p-0 pl-3 border-0">
                                                        <h5>
                                                            {this.renderCheckBox(
                                                                ssmenu.name,
                                                                `ssm_${ssmenu.id}_${smenu.id}_${menu.id}`,
                                                                this.handleSystemAdminChange,
                                                                ssmenu.isChecked
                                                            )}
                                                        </h5>
                                                        {ssmenu.menus?.map((sssmenu) => (
                                                            <ul className="list-group">
                                                                <li className="list-group-item p-0 pl-3 border-0">
                                                                    <h5>
                                                                        {this.renderCheckBox(
                                                                            sssmenu.name,
                                                                            `sssm_${sssmenu.id}_${ssmenu.id}_${smenu.id}_${menu.id}`,
                                                                            this.handleSystemAdminChange,
                                                                            sssmenu.isChecked
                                                                        )}
                                                                    </h5>
                                                                </li>
                                                            </ul>
                                                        ))}
                                                    </li>
                                                </ul>
                                            ))}
                                        </>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* <div className="col-md-12 text-center">
                        <button className="btn btn-sm btn-outline-default" onClick={this.handleSubmit}>
                            <i class="fa fa-check" aria-hidden="true"></i> Save
                        </button>
                    </div> */}
                </Modal.Body>
                <Modal.Footer>
                    {/* <button className="btn btn-sm btn-outline-default" onClick={this.props.handleModalShowHide}>
                        <i class="fa fa-times" aria-hidden="true"></i> Close
                    </button> */}
                    <button
                        className="btn btn-sm btn-outline-default"
                        onClick={this.handleSubmit}
                    >
                        <i class="fa fa-check" aria-hidden="true"></i> Save
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AddEditPermission;
